export default __webpack_public_path__ + "static/media/top_header.ca410f69.less";